module.exports = __webpack_public_path__ + "static/media/leetcode_logo.dcda7949.svg";